import { call, put, takeLatest, select } from 'redux-saga/effects'
import queryString from 'query-string'
import {
  path,
} from 'ramda'
import { request, authenticatedCall } from 'shared/helpers/sagas'
import * as types from 'store/projectList/projectListTypes'
import API from 'store/projectList/projectListApis'
import history from 'routes/history'
import { isPMOrAdmin, isModerator } from 'shared/helpers/user'

function* getProjects({payload : payload}) {
  try {
    let response = {}
    console.log("payload in get projects list ", payload)
    const loginRoles = yield select(path(['login', 'roles']))
    console.log("loginRoles ", loginRoles)
    if(isPMOrAdmin() || (loginRoles.includes('QUAL_SCHEDULER_MANAGER') && !isModerator())) {
      response = yield call(API.getProjectsRequest, payload)
    } else if (isModerator() || loginRoles.includes('QUAL_SCHEDULER_MODERATOR')) {
      response = yield call(API.getProjectsForModeratorRequest, payload) // call another api to get only projects assigned to this moderator
    }
    console.log("response ", response)
   if ( response.status === 200 ) {
      yield put({type:'FETCH_ALL_PROJECTS_SUCCEEDED', payload: response});
    } else if (response.status === 401) {
        yield put({type:'UNAUTHORIZED'})
    } else {
        yield put({type: 'FETCH_ALL_PROJECTS_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("Fetch all projects request failed: ",err);
       yield put({type:'FETCH_ALL_PROJECTS_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}

function* getProjectList({payload : payload}) {
  try {
    let response = {}
    const clientId = yield select(path(['client', 'clientId']))
    const sortBy = yield select(path(['projectList', 'sortBy']))
    const status = yield select(path(['projectList', 'status']))
    const creatorId = yield select(path(['projectList', 'creatorId']))
    const q = yield select(path(['projectList', 'q']))
    const projectAccountId = yield select(path(['user', 'selectedAccount']))
    const userId =  yield select(path(['user', 'userId']))
    const payload = {
      clientId,
      sortBy,
      status,
      creatorId,
      q,
      projectAccountId,
      userId
    }
    payload.clientId = clientId
    let queryParams
    if(payload.sortBy) queryParams = `?sortBy=${payload.sortBy}`
    if(payload.status) queryParams = queryParams? queryParams + `&status=${payload.status}` : `?status=${payload.status}`
    if(payload.creatorId) queryParams = queryParams? queryParams + `&creatorId=${payload.creatorId}` : `?creatorId=${payload.creatorId}`
    if(payload.q) queryParams = queryParams? queryParams + `&q=${payload.q}` : `?q=${payload.q}`
    const filteredClients = yield select(path(['user', 'filteredClients']))
    console.log("filteredClients in getProjectsList", filteredClients)
    response = yield call(API.getProjectsList, payload, queryParams, [...filteredClients])
    console.log("response in getProjectList", response)
   if ( response.status === 200 ) {
      yield put({type:'FETCH_PROJECTS_LIST_SUCCEEDED', payload: response});
    } else if (response.status === 401) {
        yield put({type:'UNAUTHORIZED'})
    } else {
        yield put({type: 'FETCH_ALL_PROJECTS_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("Fetch all projects request failed: ",err);
       yield put({type:'FETCH_ALL_PROJECTS_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}

export default function* projectListSaga () {
  yield takeLatest(types.FETCH_ALL_PROJECTS_REQUESTED, getProjects)
  yield takeLatest(types.FETCH_PROJECTS_LIST_REQUESTED, getProjectList)
}
